/* eslint-disable @typescript-eslint/no-explicit-any */
import { MigrationManifest } from 'redux-persist';
import { GameSave } from '../model/IPuzzle';

const migrations: MigrationManifest = {
  1: (state: any) => {
    return {
      ...state,
      game: {
        archive: [],
        currentGameIdx: 0,
      },
    };
  },
  2: (state: any) => {
    return {
      ...state,
      game: {
        ...state.game,
        archive: state.game.archive.filter((e: GameSave) => e.idx <= 487),
      },
    };
  },
  3: (state: any) => {
    // Strip heavy data from archived games to save storage.
    // Only keep player progress; puzzle data is restored from the API on load.
    return {
      ...state,
      game: {
        ...state.game,
        archive: (state.game?.archive || []).map((g: any) => ({
          id: g.id,
          idx: g.idx,
          board: [], // will be restored from API
          words: [], // will be restored from API
          bonusWords: [], // will be restored from API
          definitions: [], // will be restored from API
          x5: g.x5 || '',
          foundWords: g.foundWords || [],
          foundBonusWords: g.foundBonusWords || [],
          hintsLeft: g.hintsLeft ?? 3,
          letterStartTriggered: g.letterStartTriggered ?? false,
          letterTotalTriggered: g.letterTotalTriggered ?? false,
          shareUsed: g.shareUsed ?? false,
        })),
      },
    };
  },
  4: (state: any) => {
    // Add gridSize and totalWords to archived games so stats work
    // even after board[] and words[] are stripped.
    return {
      ...state,
      game: {
        ...state.game,
        archive: (state.game?.archive || []).map((g: any) => ({
          ...g,
          gridSize: g.gridSize ?? (g.board?.length > 0 ? g.board.length : 4),
          totalWords: g.totalWords ?? (g.words?.length > 0 ? g.words.length : undefined),
        })),
      },
    };
  },
  5: (state: any) => {
    // Migration 3 stripped words[] BEFORE migration 4 could capture totalWords,
    // and the API only returns ~2 recent puzzles, so older games permanently
    // lost their totalWords. For any played game still missing totalWords,
    // use foundWords.length (exact for completed games; a safe lower-bound
    // otherwise — places the game in the correct or a lower star bucket,
    // which is better than silently dropping it from stats).
    return {
      ...state,
      game: {
        ...state.game,
        archive: (state.game?.archive || []).map((g: any) => ({
          ...g,
          totalWords:
            g.totalWords != null
              ? g.totalWords
              : g.foundWords?.length > 0
                ? g.foundWords.length
                : undefined,
        })),
      },
    };
  },
};

export { migrations };
